import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import './CountryManage.scss';
import { getAllCountries, createNewCountryService, deleteCountryService, editCountryService } from '../../../services/countryService';
import ModalCountry from './ModalCountry';
import ModalEditCountry from './ModalEditCountry';
import { emitter } from '../../../utils/emitter' // ham tao su kien
class CountryManage extends Component {

    constructor(props) { // Ham khoi tao
        super(props);
        this.state = {
            arrCountries: [],
            isOpenModal: false,
            isOpenModalEditCountry: false,
            CountryEdit: [],
        }
    }

    async componentDidMount() {  // set bien, goi api
        await this.getAllCountryFromReact()

    }
    getAllCountryFromReact = async () => {
        let response = await getAllCountries("All");
        if (response && response.errCode == 0) {
            this.setState({
                arrCountries: response.countries
            })
            console.log(this.state.arrCountries);
        }
    }
    createNewCountry = async (data) => {

        try {
            let response = await createNewCountryService(data);
            if (response && response.errCode !== 0) {
                await this.getAllCountryFromReact()
                this.setState({
                    isOpenModal: false,
                })
                emitter.emit('EVENT_CLEAR_MODAL_DATA', { "id": "your id" });

            } else {
                console.log("Country didn't create");
            }

        } catch (error) {

        }
    }
    editCountry = async (data) => {
        try {
            let response = await editCountryService(data);
            if (response && response.errCode !== 0) {
                await this.getAllCountryFromReact()
                this.setState({
                    isOpenModalEditCountry: false,
                })
                // emitter.emit('EVENT_CLEAR_MODAL_DATA', { "id": "your id" });
                console.log('trang thai tra ve ham edit: ', response)
            } else {
                console.log("Country didn't create");
            }

        } catch (error) {

        }
    }
    handleAddNewCountry = () => {
        this.setState({
            isOpenModal: true
        })
        // alert("from handleAddNewCountry");
    }
    handleDeleteCountry = async (data) => {

        let response = await deleteCountryService(data);
        if (response && response.errCode !== 0) {
            await this.getAllCountryFromReact()
            this.setState({
                isOpenModal: false,
            })

        } else {
            console.log("Country didn't create");
        }

    }
    handleEditCountry = async (data) => {

        this.setState({
            isOpenModalEditCountry: true,
            CountryEdit: data
        })
    }
    toogleCountryModal = () => {
        this.setState({
            isOpenModal: !this.state.isOpenModal
        })
    }
    toogleCountryEditModal = () => {
        this.setState({
            isOpenModalEditCountry: !this.state.isOpenModalEditCountry
        })
    }
    render() {
        console.log('check render : ', this.state.isOpenModal);
        let arrCountries = this.state.arrCountries;
        // console.log('check render : ', arrCountrys);
        // props - properties, nested, lay data tu Thang cha chuyen cho thang con, thang cha lay du lieu goc tu API
        return (
            <div className="Countries-container">
                <ModalCountry
                    isOpen={this.state.isOpenModal}
                    tooglefromParent={this.toogleCountryModal}
                    createNewCountry={this.createNewCountry}
                />
                {this.state.isOpenModalEditCountry &&
                    <ModalEditCountry
                        isOpen={this.state.isOpenModalEditCountry}
                        tooglefromParent={this.toogleCountryEditModal}
                        currentCountry={this.state.CountryEdit}
                        editCurrentCountry={this.editCountry}

                    />
                }

                <div className='title text-center'> Manage Country by Admin</div>
                <div className="mx-1">
                    <button class="btn btn-primary px-3"
                        onClick={() => this.handleAddNewCountry()}
                    ><i class="fas fa-plus"></i>Add new Country</button>

                </div>
                <div className='Country-table mt-3 mx-1'>
                    <table id="customers">
                        <tr>
                            <th>Name</th>
                            <th>Short Name</th>
                            <th>Flag</th>
                            <th>Currency</th>
                            <th>Action</th>
                        </tr>

                        {/* su dung vong lap MAP function javascript */}
                        {arrCountries && arrCountries.map((item, index) => {
                            // console.log('check map', item, index);
                            return (
                                <tr>

                                    <td>{item.countryName}</td>
                                    <td>{item.countryShortName}</td>
                                    <td>{item.countryFlag}</td>
                                    <td>{item.countryCurrency}</td>
                                    <td>
                                        <button className='btn-edit'
                                            onClick={() => this.handleEditCountry(item)}
                                        ><i class="fas fa-pencil-alt"></i></button>
                                        <button className='btn-delete'
                                            onClick={() => this.handleDeleteCountry(item)}
                                        > <i className="fas fa-trash-alt"></i></button>

                                    </td>
                                </tr>

                            )
                        })
                        }



                    </table>
                </div>
            </div >
        );
    }

}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CountryManage);
